// import useConfig from './useConfig'
import { useQuery } from 'react-query'

/**
 * Hook for retrieving the weekly results.
 */

const useGetResults = () => {

/*
  const { data: config } = useConfig()
*/

  const fetchResults = async () => {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}api/public/getWeeklyResults.php?year=${process.env.REACT_APP_CURRENT_YEAR}`);
    return resp.json();
  }
   
   return useQuery('results', fetchResults);

}

export default useGetResults
